import { render } from "./ProductCategoryDisplay.vue?vue&type=template&id=54cac78e"
import script from "./ProductCategoryDisplay.vue?vue&type=script&lang=js"
export * from "./ProductCategoryDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__